<template>
  <div>401 page</div>
</template>

<script>
var mixin = {
  data: function() {
    return {
      message: "hello",
      foo: "abc"
    }
  }
}
export default {
  components: {},
  mixins: [mixin],
  data: function() {
    return {
      message: "goodbye",
      bar: "def"
    }
  },
  created: function() {
    console.log(this.data)
  }
}
//定义一个组件
var Component = Vue.extend({
  mixins: [mixin]
})
//new 一个组件
var component = new Component()
</script>

<style></style>
